module.exports = __webpack_public_path__ + "img/DerBaum.82d666dc.jpg";